import '.cp{font-size:1.125rem;}.ssr-plugin'
import '.et{line-height:1.75rem;}.ssr-plugin'
import '.b5{text-decoration:none;}.ssr-plugin'
import '.de{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cp et"
    >
      {translations.privacySubtitle}{' '}
      <a className="b5 de"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="b5 de"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
